
<div class="cp-win mobile">
  <div class="prize"></div>
  <div v-if="data.length" class="prize-wrapper" :class="[bigPrize ? 'prize-wrapper-3' : '']" ref="wrapper">
    <Prize
      v-for="(prize, index) in data"
      :key="index"
      :prize="prize.icon"
      :name="prize.title"
      :ref="`prize-${index + 1}`"
      :class="[bigPrize ? `prize prize-31 prize-3-${index + (index > 0 ? 2 : 1)}` : `prize prize-${index + 1}`]"
    >
    </Prize>
  </div>
  <div v-show="showButtons" class="button" @click="showShare"></div>
  <div v-show="showButtons" class="button draw" @click="lotto"></div>
  <div v-show="showButtons" class="desc">召集助力，增加更多十连次数！</div>
  <div v-show="showButtons" class="desc times">还能抽<span class="emphasis">{{chance}}</span>次</div>
  <Close is-mobile @close="handleClose" class="close"></Close>
</div>
